import { CoKitchenType } from 'models/cokitchen.model';
import { RoleType } from 'models/role.model';
import { StoreItemType } from 'models/store-item.model';
import { StoreType } from 'models/store.model';
import { FormVendorType } from 'models/vendors.model';
import { createContext, useContext } from 'react';

export type DashboardContextType = {
  activeStore: StoreType | undefined;
  setActiveStore: (store: StoreType | undefined) => void;
  activeCokitchen: CoKitchenType;
  setActiveCokitchen: (kitchen: CoKitchenType) => void;
  cokitchens: CoKitchenType[];
  setCokitchens: (kitchens: CoKitchenType[]) => void;
  showMobileSidebar: boolean;
  setShowMobileSidebar: (value: boolean) => void;
  isBackLink: boolean;
  setIsBackLink: (value: boolean) => void;
  backLinkTitle: string;
  setBackLinkTitle: (value: string) => void;
  hideSideBar: boolean;
  setHideSideBar: (value: boolean) => void;
  backLink: string;
  setBackLink: (value: string) => void;
  formVendorsList: FormVendorType[];
  isFetchingFormVendorsList: boolean;
  formIngredientCategoryList: string[];
  isFetchingFormIngredientCategoryList: boolean;
  isFetchingFormStoreItems: boolean;
  formStoreItems: StoreItemType[];
  showAddStoreModal: boolean;
  setShowAddStoreModal: (value: boolean) => void;
  roles: RoleType[] | null;
  setRoles: (value: RoleType[] | null) => void;
  stores: StoreType[];
  setStores: (value: StoreType[]) => void;
  isStoresLoading: boolean;
  setIStoresLoading: (value: boolean) => void;
  refreshStore: boolean;
  setRefreshStore: (value: boolean) => void;
  showStores: boolean;
  setShowStores: (arg0: boolean) => void;
};

export const DashboardContext = createContext({} as DashboardContextType);

const useDashboardContext = () => {
  const context = useContext(DashboardContext);
  return context;
};

export default useDashboardContext;
